import { SlidersHorizontal, Layers, HeartHandshake, Target } from "lucide-react";
import Reveal from "@/components/Reveal";

const FEATURES = [
    { icon: SlidersHorizontal, title: "Tailored Solutions", desc: "Custom strategies for your unique needs." },
    { icon: Layers, title: "Creative & Technical Expertise", desc: "Data, design and digital solutions in one place." },
    { icon: HeartHandshake, title: "Dedicated Support", desc: "We're with you at every step." },
    { icon: Target, title: "Result Driven", desc: "Focused on meaningful business outcomes." },
];

export default function WhyUs() {
    return (
        <section id="why-us" className="py-20 lg:py-28 bg-olive/15" data-testid="whyus-section">
            <div className="mx-auto max-w-7xl px-5 sm:px-8">
                <Reveal className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14">
                    <div>
                        <div className="flex items-center gap-3 mb-4">
                            <span className="h-px w-10 bg-gold-deep" />
                            <span className="text-[11px] font-semibold tracking-[0.34em] text-burgundy">WHY ANALYTROVA?</span>
                        </div>
                        <h2 className="text-4xl sm:text-5xl text-charcoal">Why Analytrova?</h2>
                    </div>
                    <p className="max-w-md text-charcoal/70 md:text-right">
                        We focus on quality, creativity and real results — not just numbers.
                    </p>
                </Reveal>

                <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-8">
                    {FEATURES.map((f, i) => (
                        <Reveal key={f.title} delay={i * 0.08}>
                            <div
                                className="group border-t-2 border-burgundy/20 pt-7 h-full transition-colors duration-300 hover:border-burgundy"
                                data-testid={`why-feature-${i}`}
                            >
                                <div className="flex items-start justify-between">
                                    <span className="w-11 h-11 rounded-full bg-burgundy text-cream flex items-center justify-center transition-transform duration-300 group-hover:-translate-y-1">
                                        <f.icon className="w-5 h-5" strokeWidth={1.7} />
                                    </span>
                                    <span className="font-serif italic text-4xl text-burgundy/15 select-none">
                                        0{i + 1}
                                    </span>
                                </div>
                                <h3 className="mt-6 text-xl text-charcoal">{f.title}</h3>
                                <p className="mt-2 text-sm text-charcoal/65 leading-relaxed">{f.desc}</p>
                            </div>
                        </Reveal>
                    ))}
                </div>
            </div>
        </section>
    );
}
